import { hasData } from "./hasData";

export function ifNull(val1,val2) {
    return (hasData(val1) ? val1 : val2)
}